var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHelpIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 339.676,
    height: 265.405,
    viewBox: "0 0 339.676 265.405",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:#ddecff;}.b,.i,.s{mix-blend-mode:multiply;isolation:isolate;}.c{fill:#60a8ff;}.d{fill:#223a7a;}.e,.x{fill:#fff;}.f{fill:#1c83ff;}.g{fill:#ff9d8c;}.h{fill:#8593b6;}.j{fill:#8e9bbb;}.k{fill:#dee1eb;}.l{fill:#818fb3;}.m{fill:#6baeff;}.n{fill:#43588e;}.o{fill:#f6f7fa;}.p{fill:#d9dee8;}.q{fill:#596b9b;}.r{fill:#7a89af;}.s{fill:#bdc4d7;}.t{fill:#6f7fa9;}.u{fill:#9ca6c3;}.v{fill:#d2e6ff;}.w{fill:#ff5f42;}.x{font-size:7px;font-family:Quicksand-Bold, Quicksand;font-weight:700;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-101 -114.008)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M90.506,323.271s-42.3-31.3-54.475-84.584S42.44,120.8,77.689,88.167s98.7-10.656,126.9,16.651l28.2,27.307S259.7,147.442,294.95,146.11s66.652,48.62,74.984,87.914S358.4,325.27,358.4,325.27Z",
    transform: "translate(68.701 42.154)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M71.091,331.726s-29.187-16.65-36.8-55.279S59.67,202.518,62.842,183.2s-3.807-43.291,25.381-61.939,81.217-11.989,100.886-16.651,42.512-36.631,81.851-29.3,77.41,29.3,79.314,77.258-12.69,49.286,1.9,75.261,20.3,43.957,13.325,70.6-21.573,33.967-21.573,33.967Z",
    transform: "translate(71.869 41.691)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M158.885,347.262c-1.906-2-29.857-57.944,1.271-109.227s109.266-45.289,140.394-25.309,46.375,45.955,49.551,73.263-17.787,69.932-17.787,69.932Z",
    transform: "translate(33.275 17.497)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(114.445 133.651)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(256.953 110.948)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 43.957,
    height: 25.975,
    rx: 5
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M410.772,275.749l5.691-13.487H405.082Z",
    transform: "translate(-388.794 -239.617)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.173 3.07)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(13.67 1.15)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M411.984,243.675h10.279v1.5l5.039-2.906-5.039-2.905v1.5H411.984Z",
    transform: "translate(-411.984 -239.368)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 8.714)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M427.3,251.7H417.023v-1.5l-5.039,2.906,5.039,2.905v-1.5H427.3Z",
    transform: "translate(-411.984 -250.196)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M402.359,252.191l-.489.178a15.552,15.552,0,0,1-2.317-3.638,13.052,13.052,0,0,1-.819-4.213l.357-.149-2.173-5.2a4.26,4.26,0,0,0-1.056,1.2c-1.231,2.079-1.108,5.269.13,8.385s2.56,5.9,4.974,7.645a4.77,4.77,0,0,0,3.593,1.062Z",
    transform: "translate(-394.998 -238.179)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M405.919,254.57l-.675.245,2.225,5.326a3.973,3.973,0,0,0,.672-.291,1.3,1.3,0,0,0,.585-1.614l-1.162-2.929A1.294,1.294,0,0,0,405.919,254.57Z",
    transform: "translate(-396.999 -241.171)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M399.283,238.015a5.145,5.145,0,0,0-.872.41l2.22,5.312.748-.312a1.293,1.293,0,0,0,.707-1.663l-1.167-3A1.291,1.291,0,0,0,399.283,238.015Z",
    transform: "translate(-395.665 -237.939)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(67.32 138.53)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M149.219,351.985V292.043s-.666-16.151,7.826-20.813,44.291-2.164,44.291-2.164v82.919Z",
    transform: "translate(-149.207 -268.397)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(73.518 33.412)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(49.122 49.674)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M225.938,199.5s-2.165,18.148-3,19.647l-.832,1.5-4.163,2.831s7.992,11.322,17.816,13.153,8.991-4,8.991-4l-1.5-3.164,2-17.316S227.437,204,225.938,199.5Z",
    transform: "translate(-217.946 -199.504)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M211.532,230.472l6.494-2.831s4.163,6.827,13.82,10.823,9.824,1.665,10.323,0a6.329,6.329,0,0,0-.167-3.5l.715-5.83,3.862,1.287,13.406,108.442-34.466,1.665Z",
    transform: "translate(-167.572 -155.323)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(75.763 73.928)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M251.05,229.641s2.331,5.384,4.5,18.038a430.439,430.439,0,0,1,4.662,48.62c.5,14.653.832,48.12.832,48.12H304.5c.5,0,3.5-16.484,3.5-16.484s-18.981-16.262-19.98-18.926c-.666-1.776-.333-34.688-3.164-49.84s-6.494-18.2-14.154-21.978A166.207,166.207,0,0,0,251.05,229.641Z",
    transform: "translate(-251.05 -229.641)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(97.172 99.889)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M278.888,331.638a.4.4,0,0,1-.4-.4c0-1.19-.212-18.1-.416-34.461s-.416-33.276-.416-34.472a.4.4,0,0,1,.8,0c0,1.19.212,18.1.415,34.461s.417,33.276.417,34.472A.4.4,0,0,1,278.888,331.638Z",
    transform: "translate(-277.653 -261.9)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.491 165.558)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M171.52,343.5l-.333,23.144H221.8s2.165-19.648,1.332-21.479S171.52,343.5,171.52,343.5Z",
    transform: "translate(-171.187 -343.499)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "i",
    transform: "translate(58.506 51.637)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M239.259,219.128a26.455,26.455,0,0,0,7.082,3.8l1.188-10.3s-13.383-6.131-17.923-10.691C230.555,207.125,232.889,213.992,239.259,219.128Z",
    transform: "translate(-229.606 -201.943)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(54.212 12.144)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M262.139,156.6a36.03,36.03,0,0,1,4.163,13.32c.666,7.327,0,26.141-5.994,34.134s-18.482,5.662-24.143.833c-5.2-4.432-10.324-9.325-11.656-18.982s2.83-27.972,14.653-31.8S262.139,156.6,262.139,156.6Z",
    transform: "translate(-224.271 -152.87)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(63.282 164.202)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M279.36,355.85s-.588,0-1.481-.024c-.209-.008-.443,0-.684-.008-.861-.024-1.907-.048-2.962-.081l-.708-.024c-1.046-.024-1.939.1-2.776.056h-.024c-.177-.008-.435.016-.644.024a1.57,1.57,0,0,1-.266.008,3.909,3.909,0,0,1-1.1-.435,74.862,74.862,0,0,0-17.27-2.3c-7.436.032-14.108.539-15.194-.37-1.094-.925-1.754-10.269,4.6-10.881l7.806,2.962s17.826-2.117,24.361,2.7C279.561,352.3,279.36,355.85,279.36,355.85Z",
    transform: "translate(-235.541 -341.815)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(24.987 8.661)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M276.786,357.871c-.177-.008-.435.016-.644.024a7.555,7.555,0,0,0-.684-.917c-2.012-2.052-6.873-3.38-8.635-3.807a.3.3,0,0,1-.225-.362.309.309,0,0,1,.37-.225c2.567.62,8.016,2.205,9.561,4.8C276.577,357.46,276.706,357.71,276.786,357.871Z",
    transform: "translate(-266.589 -352.577)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(27.285 6.635)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M280.854,357.346c-.233-.006-.475-.011-.707-.025-2.2-4.006-5.791-5.156-10.233-6.585l-.263-.087a.309.309,0,0,1-.192-.383.305.305,0,0,1,.383-.192l.256.087C274.794,351.669,278.573,352.88,280.854,357.346Z",
    transform: "translate(-269.444 -350.06)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(29.826 4.823)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M285.115,357c-.209,0-.443,0-.684-.009a17.552,17.552,0,0,0-11.577-8.582.3.3,0,0,1-.249-.352.311.311,0,0,1,.352-.241C278.968,348.941,283.816,353.849,285.115,357Z",
    transform: "translate(-272.602 -347.808)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(46.442)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M226.62,174.716a15.586,15.586,0,0,0,6.244-6.66,18.947,18.947,0,0,0,2.248-9.324s4.662-.749,11.656,1.332,15.318,4.912,22.312.916,6.993-10.407,3.58-13.071c-3.823-2.983-11.405-1.165-11.405-1.165s2.913-2.83,1.332-4.5-7.326.5-7.326.5-6.993-5.578-20.23-4.912-19.565,9.908-20.314,20.23,3,20.646,3,20.646Z",
    transform: "translate(-214.616 -137.779)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "i",
    transform: "translate(81.879 39.236)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M262.072,186.736c-.75,1.849-.732,4-.921,5.959-.147,1.527-.427,3.307.971,4.338.669.493,3.829,1.82,2.2,2.9a4.273,4.273,0,0,1-2.364.266c-.486-.023-.977-.043-1.462-.08-.522-.039-1.034-.2-1.556-.2a.3.3,0,0,0-.152.563,6.573,6.573,0,0,0,3.053.727,4.617,4.617,0,0,0,2.528-.445,1.81,1.81,0,0,0,1.154-1.3,2.066,2.066,0,0,0-.994-1.783c-.63-.467-1.4-.684-2.038-1.139-.882-.632-.81-1.695-.748-2.678.149-2.368.694-4.694.905-7.051.032-.361-.467-.361-.581-.079Z",
    transform: "translate(-258.649 -186.534)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.391 42.089)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M270.457,192.965c-.249,1.4-1.269,2.4-2.281,2.217s-1.63-1.461-1.381-2.865,1.269-2.4,2.281-2.218S270.706,191.561,270.457,192.965Z",
    transform: "translate(-266.741 -190.078)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(75.374 40.812)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M254.559,191.543c-.225,1.515-1.292,2.61-2.383,2.448s-1.793-1.522-1.568-3.036,1.292-2.61,2.384-2.448S254.785,190.029,254.559,191.543Z",
    transform: "translate(-250.567 -188.491)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(88.57 37.191)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M267.535,185.991c.777.131,1.563,0,2.347.052.189.014.376.041.563.059.134.013-.25-.039-.064-.008l.121.019c.1.018.2.038.293.061.167.041.329.1.5.141a1.911,1.911,0,0,0,.474.061l.257-.035-.162.029a1.554,1.554,0,0,0,.319-.034.865.865,0,0,0,.6-1.052,1,1,0,0,0-.17-.34c-.033-.043-.067-.087-.1-.13l.094.108c-.033-.047-.068-.093-.1-.137a.5.5,0,0,0-.178-.178c-.062-.048-.124-.1-.188-.143a2.289,2.289,0,0,0-.722-.29,5.876,5.876,0,0,0-1.431-.184,9.948,9.948,0,0,0-1.416.113,2.723,2.723,0,0,0-1.214.449.8.8,0,0,0-.375.783.773.773,0,0,0,.563.653Z",
    transform: "translate(-266.964 -183.993)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(73.148 36.049)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M254.913,183.487a3.278,3.278,0,0,0-.325-.168c-.095-.043-.352-.178-.158-.072-.071-.039-.142-.078-.213-.114a4.87,4.87,0,0,0-1.006-.36,6.674,6.674,0,0,0-2.339-.161,5.444,5.444,0,0,0-2.311.723,1.472,1.472,0,0,0-.291.206c-.057.072-.113.146-.168.22l.047-.072a.819.819,0,0,0-.349.678.676.676,0,0,0,.36.6,1.02,1.02,0,0,0,.809.007h-.421a1.51,1.51,0,0,0,.627-.006c.009,0,.225-.056.082-.026s.227-.027.266-.033.3-.031.031-.006l.146-.017c.126-.016.251-.031.377-.041.55-.044,1.1-.068,1.648-.087.511-.017,1.032-.021,1.542,0,.219.009.437.017.656.023.124,0,.071.023-.013,0,.044.014.092.023.137.035.091.025.18.055.269.089a.767.767,0,0,0,.912-.448.776.776,0,0,0-.316-.966Z",
    transform: "translate(-247.801 -182.574)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(77.659 56.397)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M259.96,211.569a7.53,7.53,0,0,1,3.762-3.387c-1.4-.142-7.982-.752-9.644.192-1.862,1.057.344,5.3,4.195,5.515a5.261,5.261,0,0,0,1.123-.065A5.559,5.559,0,0,1,259.96,211.569Z",
    transform: "translate(-253.406 -207.858)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(53.784 50.506)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M223.739,201.2s.666,2.581,4.5,5.579a44.4,44.4,0,0,0,9.38,5.189l.443-1.943s-5.744-2.5-8.408-5.245-3-4.246-3-4.246Z",
    transform: "translate(-223.739 -200.538)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(66.138 58.554)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M241.722,210.545a4.814,4.814,0,0,1,5.017,3.87c.215,1.577-1.266,3.344-4.73,1.791C237.705,214.277,238.64,210.688,241.722,210.545Z",
    transform: "translate(-239.09 -210.538)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(49.288 0.543)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M225.063,170.019s1.331-9.569,7.743-16.068c12.238-12.4,22.645-11.655,22.645-11.655s-.084-1.749-4-3.081c-3.674-1.251-5.328-.583-5.328-.583s-10.074.832-18.565,10.24a39.87,39.87,0,0,0-9.408,21.4Z",
    transform: "translate(-218.153 -138.455)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(42.445 30.755)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M222.487,176.183c-8.017-1.359-12.488,4.912-12.821,11.239s4.264,11.137,10.407,10.657C233.893,197,232.311,177.848,222.487,176.183Z",
    transform: "translate(-209.649 -175.995)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.157 3.469)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M219.261,192.77a5.462,5.462,0,0,1-4.928-2.937,6.088,6.088,0,0,1,.234-6.292.3.3,0,1,1,.5.34,5.481,5.481,0,0,0-.2,5.663,4.853,4.853,0,0,0,4.552,2.62,5.282,5.282,0,0,0,4.372-2.36,6.67,6.67,0,0,0,.66-5.913,4.5,4.5,0,0,0-4.491-2.954.3.3,0,0,1-.079-.6,5.046,5.046,0,0,1,5.134,3.337,7.29,7.29,0,0,1-.723,6.463,5.874,5.874,0,0,1-4.857,2.628Z",
    transform: "translate(-213.571 -180.306)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 72.818)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M202.366,228.262s-24.31,5.994-32.8,15.651-12.488,57.278-12.654,66.1S162.905,322.5,166.568,325s19.814,6.994,32.8,7.659,25.309,0,25.309,0a17.3,17.3,0,0,1,1.956-6.993c1.853-3.861,4.2-4.662,4.2-4.662l-11.156-4s-1.954-35-5-51.95C211.192,245.578,202.366,228.262,202.366,228.262Z",
    transform: "translate(-156.908 -228.262)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(78.856 74.83)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M261.79,311.905a.389.389,0,0,1-.163-.035.4.4,0,0,1-.205-.53c2.277-5.138,4.638-15.228,5.967-22.306l.109-.571c.4-2.082.9-4.672-.1-6.459-.509-.912-1.659-2.89-2.766-4.792-1.148-1.974-2.233-3.839-2.534-4.4-.586-1.087,1.26-3.991,3.933-7.974.721-1.077,1.346-2.005,1.709-2.635.952-1.648.318-3.158-.416-4.907l-.249-.6c-.666-1.634-1.423-3.271-2.154-4.854-.3-.647-.6-1.295-.893-1.946q-.587-1.29-1.181-2.621a153.634,153.634,0,0,0-7.9-15.908.4.4,0,0,1,.692-.411,154.231,154.231,0,0,1,7.944,15.99q.6,1.327,1.179,2.619.442.973.89,1.94c.736,1.59,1.5,3.236,2.168,4.887l.247.594c.749,1.783,1.523,3.626.37,5.621-.377.653-1.008,1.593-1.738,2.681-1.394,2.077-4.293,6.4-3.893,7.142.295.546,1.376,2.405,2.521,4.374,1.109,1.907,2.262,3.889,2.773,4.8,1.143,2.044.611,4.794.184,7l-.109.567c-.485,2.578-3.049,15.776-6.022,22.484A.4.4,0,0,1,261.79,311.905Z",
    transform: "translate(-254.894 -230.763)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(41.454 73.498)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M228.99,313a.4.4,0,0,1-.285-.118c-1.893-1.906-11.017-17.706-11.7-20.677-.372-1.626.562-5.752,1.465-9.742.7-3.091,1.423-6.288,1.217-7.153-.307-1.293-2.64-3.2-4.9-5.043-2.726-2.226-5.544-4.528-6.09-6.6-.62-2.357-.09-17.114.261-26.879.126-3.511.225-6.284.225-7.274a.4.4,0,0,1,.4-.4h0a.4.4,0,0,1,.4.4c0,1-.1,3.784-.226,7.3-.328,9.127-.876,24.4-.286,26.646.479,1.82,3.317,4.138,5.821,6.184,2.469,2.017,4.8,3.922,5.171,5.48.249,1.046-.43,4.044-1.215,7.515-.842,3.721-1.8,7.937-1.465,9.386.666,2.913,9.624,18.416,11.482,20.288a.4.4,0,0,1-.286.686Z",
    transform: "translate(-208.417 -229.107)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(28.905 102.67)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M193.228,313.164a.461.461,0,0,1-.057,0,.4.4,0,0,1-.342-.455c.3-2.093,4.915-43.78,5.126-46.973a.4.4,0,0,1,.428-.375.4.4,0,0,1,.375.428c-.212,3.2-4.837,44.937-5.133,47.033A.4.4,0,0,1,193.228,313.164Z",
    transform: "translate(-192.825 -265.356)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.414 146.343)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M224.3,335.081a.4.4,0,0,1-.151-.03c-1.024-.414-5.546-1.94-11.271-3.87-11.555-3.9-27.381-9.234-30.39-10.8a.4.4,0,0,1,.371-.714c2.954,1.535,19.4,7.08,30.276,10.749,5.737,1.935,10.27,3.463,11.316,3.887a.4.4,0,0,1-.151.776Z",
    transform: "translate(-182.274 -319.623)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.756 170.487)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M216.645,357.537c-10.169,0-29.884-1.834-44.861-7.131a.4.4,0,1,1,.268-.759c18.919,6.692,45.388,7.835,50.312,6.729a.4.4,0,0,1,.176.786A32.127,32.127,0,0,1,216.645,357.537Z",
    transform: "translate(-171.515 -349.624)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 82.681)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M81.832,228.164c3.158,2.776,7.156,4.557,9.926,7.768,1.09,1.263,2.07,2.608,3.081,3.933.736.964,2.7,2.563,3.022,3.775.141.534.111-.189-.031-.724-.006-.023-.018-.044-.024-.067-.276-2.454-.474-4.917-.56-7.385s.068-4.934-.087-7.391c-.217-3.468-1.3-6.825-4.134-9-1.385-1.061-3.166-1.708-4.439-2.886-1.209-1.119-.724-2.4-.014-3.647a12.426,12.426,0,0,0,1.731-3.659,6.459,6.459,0,0,0-1.055-4.4c-1.648-2.768-5.305-5.855-8.768-5.441-2.888.346-3.216,3.677-3.175,6,.04,2.257.264,4.506.286,6.764.022,2.319-.373,4.6-.406,6.9C77.13,222.631,78.945,225.625,81.832,228.164Z",
    transform: "translate(-67.826 -199)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M108.9,268.251a37.061,37.061,0,0,1,3.127-5.963,45.91,45.91,0,0,0,4.73-8.094c1.167-2.991,1-6.189,1.111-9.338.084-2.315.772-4.623.586-6.943-.089-1.113-.73-2.913-2.17-2.729-1.12.143-1.786,1.532-2.216,2.418a42.589,42.589,0,0,0-1.831,4.819c-.217.635-.426,1.281-.7,1.894-.16.357-.67,1.227-1.151,1.107-.818-.2-.075-3.543.047-4.134.612-2.97,1.531-5.732,1.659-8.79.185-4.433-.159-9.71-4.5-12.134-1.133-.633-2.569-1.011-3.646-.064s-1.362,2.555-1.52,3.889c-.484,4.094.48,7.97,1.791,11.822,1.083,3.18,2.374,6.462,2.468,9.863.09,3.274-1.613,6.175-2.412,9.267a29.316,29.316,0,0,0-1.017,9.138c-.008,2,.064,3.977.211,5.971.134,1.833.294,3.666.517,5.49.046.369.088.754.137,1.14-.7-1.7-.95-3.638-1.533-5.342-1.037-3.028-2.24-5.995-3.235-9.038a74.792,74.792,0,0,0-2.682-7.464,18.084,18.084,0,0,0-4.145-6.33,6.048,6.048,0,0,0-4.073-1.583,11.259,11.259,0,0,0-2.8.6,3.151,3.151,0,0,1-3.01-.53c-3.107-2.389-4.052-6.671-6.353-9.7-1.716-2.256-5.786-6.1-8.78-3.641-1.587,1.3-2.025,3.827-1.942,5.759a13.957,13.957,0,0,0,2.426,6.671c1.342,2.156,3.075,4.087,4.309,6.3a6.69,6.69,0,0,1,.728,4.042,9.641,9.641,0,0,0,.244,4.081c1.424,4.032,5.872,3.47,9.331,3.575a25.892,25.892,0,0,1,7.316,1.208,8.134,8.134,0,0,1,5.333,5.25c.686,1.9,1.054,4.06,2.348,5.674a6.035,6.035,0,0,0,2.3,1.713c1.349.6,5.462.855,5.492.48a18.516,18.516,0,0,1,1.072-3.778C107.165,272.6,107.988,270.413,108.9,268.251Z",
    transform: "translate(-65.556 -203.047)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M137.558,277.352c-.358-2.3-.289-4.845-1.38-6.961a.316.316,0,0,0-.426-.112c-.782.434-.814,1.7-.879,2.471-.105,1.284-.027,2.572-.185,3.852a28.8,28.8,0,0,1-1.608,6.691,7.193,7.193,0,0,1-5.007,4.509,12.669,12.669,0,0,0-4.382,1.933,9.215,9.215,0,0,0-2.57,3.544,53.131,53.131,0,0,0-3.138,11.556c-.5,2.609-.917,5.23-1.55,7.813a76.677,76.677,0,0,0-1.676,7.787c-.061.133-.126.265-.183.4-.166.394.451.607.664.279,2.5-3.848,5.547-7.3,9.7-9.424,1.877-.957,4.37-1.156,5.935-2.66a5.2,5.2,0,0,0,1.177-4.447,13.972,13.972,0,0,0-2.235-5.471,4.623,4.623,0,0,1-1-3.146,4.056,4.056,0,0,1,2.031-2.467c1.728-1.073,3.748-1.555,5.163-3.1a8.478,8.478,0,0,0,2.188-5.158A35.571,35.571,0,0,0,137.558,277.352Z",
    transform: "translate(-75.12 -212.908)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M97.361,293.417a33.164,33.164,0,0,0-7.867-7.283c-1.6-1.062-5.37-3.157-6.132-.025-.446,1.837,1.35,3.642,2.533,4.792,1.777,1.729,3.832,3.222,5.332,5.214-1.857.593-3.8.708-5.409,1.992-1.91,1.519-2.766,4.454-.873,6.315a12.011,12.011,0,0,0,3.3,2.02c1.494.724,3.015,1.379,4.546,2.018a38.324,38.324,0,0,1,9.472,5.044c2.874,2.3,5.575,6.2,5.8,9.963.023.359-.114.032.1-.132.117.105.51-.083.509-.293a39.667,39.667,0,0,0-3.342-16.006A66.854,66.854,0,0,0,97.361,293.417Z",
    transform: "translate(-69.019 -215.684)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.694 25.411)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M91.3,230.947c1.217,2.525,2.49,4.994,3.841,7.458a59.816,59.816,0,0,1,3.573,7.256c1.2,3.115,2.455,6.185,3.721,9.272a91.461,91.461,0,0,1,3.437,9.819,116.384,116.384,0,0,1,3.889,19.966,81.1,81.1,0,0,1,.406,10.32c-.074,2.692-.377,5.355-.63,8.033a47.49,47.49,0,0,0-.22,8.4c.195,2.337.567,5.115,2.38,6.783a.417.417,0,0,0,.652-.5c-2.155-4.42-2.034-9.237-1.622-14.03.228-2.646.543-5.278.633-7.934a79.421,79.421,0,0,0-.337-10.13,119.841,119.841,0,0,0-3.655-19.568,88.419,88.419,0,0,0-3.214-9.682c-1.254-3.174-2.7-6.26-3.918-9.45-2.2-5.768-5.547-10.882-8.512-16.257-.154-.279-.559-.034-.423.248Z",
    transform: "translate(-91.27 -230.576)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(38.925 49.672)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M114.28,284a47.747,47.747,0,0,1,2.137-12.252c.661-1.869,1.461-3.686,2.1-5.562.526-1.55,1.314-3.677.909-5.325a.19.19,0,0,0-.364,0c-.271.942-.241,1.974-.436,2.939a26,26,0,0,1-.736,2.776c-.621,1.941-1.433,3.8-2.137,5.712A28.265,28.265,0,0,0,113.992,284a.145.145,0,0,0,.289,0Z",
    transform: "translate(-113.924 -260.722)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14.926 48.529)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M84.119,259.58c1.667,4.028,6.68,4.26,10.33,5.162a9.68,9.68,0,0,1,5.913,4.641,35.462,35.462,0,0,1,3.377,8.127.025.025,0,0,0,.048-.014c-1.02-4.828-2.484-10.641-7.46-12.887-3.988-1.8-9.243-.9-11.794-5.2-.126-.212-.515-.07-.414.174Z",
    transform: "translate(-84.102 -259.302)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(36.636 72.224)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M111.09,288.829c.2.268.38.547.585.81a2.185,2.185,0,0,0,.332.357.772.772,0,0,0,.464.237.1.1,0,0,0,.087-.151,1.6,1.6,0,0,0-.348-.318c-.119-.105-.241-.208-.357-.318-.233-.221-.447-.46-.674-.686-.044-.043-.129.015-.089.068Z",
    transform: "translate(-111.079 -288.745)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(26.154 84.716)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M98.122,304.636a40.6,40.6,0,0,1,7.636,8.214,49.664,49.664,0,0,1,2.781,4.575,51.04,51.04,0,0,1,2.248,5.3c.055.137.3.139.284-.038-.4-3.788-2.8-7.035-4.72-10.186a24.315,24.315,0,0,0-3.573-4.322,31.775,31.775,0,0,0-4.4-3.881c-.2-.138-.447.181-.258.336Z",
    transform: "translate(-98.055 -304.267)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(40.54 80.596)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M124.511,299.178c-1.385.785-1.43,2.973-1.457,4.37-.052,2.684.612,5.2-.566,7.762-1.064,2.31-2.764,4.24-4.1,6.385-1.251,2.008-2.484,4.575-2.457,6.993,0,.14.216.218.281.076a29.145,29.145,0,0,0,1.045-3.494,14.667,14.667,0,0,1,1.707-3.6,59.436,59.436,0,0,0,3.908-5.95c1.1-2.259.938-4.5.865-6.944-.046-1.56-.2-4.068,1.057-5.229.2-.182-.056-.494-.282-.365Z",
    transform: "translate(-115.93 -299.147)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M111.153,331.159c-5.579-.077-16.207-.138-16.207-.138l2.63,19.525a8.853,8.853,0,0,0,8.773,7.671h9.607a8.853,8.853,0,0,0,8.774-7.671l2.63-19.525S116.732,331.082,111.153,331.159Z",
    transform: "translate(-71.294 -224.774)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(123.323 150.853)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(61.589 1.443)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M419.954,286.391l-31.83,63.05-92.8.666,28.639-64.6Z",
    transform: "translate(-295.326 -285.504)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M218.8,349.365l.018-5.047h60.072l27.64-60.608H402.6l2.415,2.331H311.161l-28.722,63.272S218.8,349.2,218.8,349.365Z",
    transform: "translate(-218.796 -283.71)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(116.241 31.153)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M385.024,328.391c-1.049,3.145-6.738,5.574-12.709,5.424s-9.961-2.82-8.913-5.964,6.738-5.574,12.709-5.424S386.073,325.246,385.024,328.391Z",
    transform: "translate(-363.235 -322.42)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(63.24 1.929)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M297.779,350.184a.413.413,0,0,1-.167-.036.4.4,0,0,1-.2-.533l28.829-63.508h94.113a.4.4,0,1,1,0,.8H326.761l-28.615,63.036A.4.4,0,0,1,297.779,350.184Z",
    transform: "translate(-297.377 -286.107)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.422 216.456)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.328 4.829)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "q",
    width: 110.392,
    height: 24.476
  }), /*#__PURE__*/React.createElement("rect", {
    className: "r",
    width: 198.617,
    height: 24.476,
    transform: "translate(109.762)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M186.821,371.228H76.429v4.5H384.808v-4.5Z",
    transform: "translate(-71.101 -366.399)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "t",
    width: 120.549,
    height: 5.994
  }), /*#__PURE__*/React.createElement("rect", {
    className: "u",
    width: 198.617,
    height: 5.994,
    transform: "translate(119.919)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(47.935 59.85)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 47.704,
    height: 28.189,
    rx: 5.426
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M194.645,186.645l-14.636-6.176v12.352Z",
    transform: "translate(-135.835 -172.551)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.911 11.398)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 2.696,
    cy: 2.696,
    r: 2.696
  }), /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 2.696,
    cy: 2.696,
    r: 2.696,
    transform: "translate(9.245)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 2.696,
    cy: 2.696,
    r: 2.696,
    transform: "translate(18.49)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(189.242)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M401.135,96.262H311.167A10.462,10.462,0,0,0,300.7,106.724v42.681a10.462,10.462,0,0,0,10.462,10.462h8.064c.226,3.869-.328,9.624-3.558,16.983a45.207,45.207,0,0,0,19.505-16.983h65.957A10.462,10.462,0,0,0,411.6,149.405V106.724A10.462,10.462,0,0,0,401.135,96.262Z",
    transform: "translate(-300.705 -96.262)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M366.444,120.461H321.821a2.22,2.22,0,0,1-2.22-2.22h0a2.22,2.22,0,0,1,2.22-2.22h44.623a2.22,2.22,0,0,1,2.22,2.22h0A2.22,2.22,0,0,1,366.444,120.461Z",
    transform: "translate(-304.394 -100.119)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M398.441,136.947h-77.48a1.36,1.36,0,0,1-1.36-1.359h0a1.36,1.36,0,0,1,1.36-1.36h77.48a1.36,1.36,0,0,1,1.359,1.36h0A1.359,1.359,0,0,1,398.441,136.947Z",
    transform: "translate(-304.394 -103.674)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M398.441,146.326h-77.48a1.36,1.36,0,0,1-1.36-1.359h0a1.36,1.36,0,0,1,1.36-1.36h77.48a1.36,1.36,0,0,1,1.359,1.36h0A1.359,1.359,0,0,1,398.441,146.326Z",
    transform: "translate(-304.394 -105.505)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M381.54,156.326H320.961a1.36,1.36,0,0,1-1.36-1.359h0a1.36,1.36,0,0,1,1.36-1.36H381.54a1.36,1.36,0,0,1,1.36,1.36h0A1.359,1.359,0,0,1,381.54,156.326Z",
    transform: "translate(-304.394 -107.457)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M411.108,120.461H389.821a2.22,2.22,0,0,1-2.22-2.22h0a2.22,2.22,0,0,1,2.22-2.22h21.287a2.22,2.22,0,0,1,2.22,2.22h0A2.22,2.22,0,0,1,411.108,120.461Z",
    transform: "translate(-317.669 -100.119)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(203.249 90.079)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "e",
    width: 27.39,
    height: 19.731,
    rx: 2,
    transform: "translate(0 8.686)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.104 9.137)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M332,231.91a.6.6,0,0,1-.384-.138l-13.155-10.865a.6.6,0,0,1,.769-.93l12.76,10.538L344.422,219.7a.6.6,0,1,1,.792.91l-12.82,11.157A.606.606,0,0,1,332,231.91Z",
    transform: "translate(-318.239 -219.547)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 7.95)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M318.842,240.3a.6.6,0,0,1-.437-1.02l9.2-9.672a.6.6,0,1,1,.874.832l-9.2,9.672A.6.6,0,0,1,318.842,240.3Z",
    transform: "translate(-318.239 -229.425)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.812 8.08)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M348.9,239.982a.6.6,0,0,1-.427-.177l-9.163-9.188a.6.6,0,0,1,.856-.852l9.162,9.188a.6.6,0,0,1-.427,1.029Z",
    transform: "translate(-339.129 -229.587)"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(20.57)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "w",
    cx: 8.075,
    cy: 8.075,
    r: 8.075
  }), /*#__PURE__*/React.createElement("text", {
    className: "x",
    transform: "translate(2.4 8.826)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "85"))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpIcon);
export default __webpack_public_path__ + "static/media/helpIcon.d2a18e720dc21915caaaba957affe9e5.svg";
export { ForwardRef as ReactComponent };